import { i18nTranslate } from 'src/utils'
import { isB2BAccount } from 'src/utils'
import { userDetailsSchema } from './validationSchema'
import { userDetailsformInput } from './formInputSMSverify'

export const accountOverviewFormDataSMSverify = async (userResponse, getFormRefData) => {
  const labelValue = isB2BAccount()
    ? i18nTranslate('account.profileInfo', 'Profile Information')
    : i18nTranslate('account.overview', 'Account Overview')
  return {
    label: labelValue,
    schema: userDetailsSchema(userResponse),
    formInput: await userDetailsformInput(userResponse, getFormRefData),
    button: {
      label: i18nTranslate('account.saveChanges', 'Save Changes'),
      dataTestId: 'qa-save-changes',
    },
    editButton: {
      label: i18nTranslate('account.editButton', 'Edit'),
      dataTestId: 'qa-edit-button',
    },
    cancelButton: {
      label: i18nTranslate('account.cancelButton', 'Cancel'),
      dataTestId: 'qa-cancel-button',
    },
    verifyButton: {
      label: i18nTranslate('account.verifyButton', 'Verify'),
      dataTestId: 'qa-verify-button',
    },
  }
}

export const loyaltyRewardsFormData = {
  label: i18nTranslate('nuskinEnjoyRewards.title', 'Nu Skin Rewards'),
  dataTestId: 'loyalty-rewards',
  offTitle: i18nTranslate(
    'account.loyaltyOffTitle',
    'Would you like to Opt In to Nu Skin Rewards program?'
  ),
  onTitle: i18nTranslate(
    'account.loyaltyOnTitle',
    'You have now Opted in to Nu Skin Rewards program!'
  ),
  optOutTxt: i18nTranslate(
    'account.loyaltyoptOutTxt',
    'Yes, I would like to Opt-in'
  ),
  optInTxt: i18nTranslate('account.loyaltyoptOffTxt', 'Opted In'),
  brandAffiliateUserTxt: i18nTranslate(
    'account.loyaltybrandAffiliateUserTxt',
    'Nu Skin Rewards Program is exclusively for Retail Customers and Members!'
  ),
  buyerUserTxt: i18nTranslate(
    'account.loyaltybuyerUserTxtTxt',
    'You are still not opted in to the Nu Skin Rewards Program. You will automatically be opted in when your Primary User opts in.'
  ),
}
